import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsFiltersSearchParamsUpdatedEvent extends EventV2<object> {}
